window.injectCache = {};

export default async function injectComponent(themeType, type, which) {
  
  if (!type || !themeType) return;

  try {

    if (which === 'component') {
      if (!window.injectCache[`components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`]) {
        const awaitComponent = await import(/* webpackMode: "lazy" */ `components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`);
        window.injectCache[`components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`] = awaitComponent;
      }
      return `components/Templates/components/${themeType.toLowerCase()}/${type}/index.js`;
    }
    if (which === 'style') {
      if (window.injectCache[`components/Templates/components/${themeType.toLowerCase()}/${type}/styling.js`]) return window.injectCache[`components/Templates/components/${themeType.toLowerCase()}/${type}/styling.js`];
      const awaitStyle = await import(/* webpackMode: "lazy" */ `components/Templates/components/${themeType.toLowerCase()}/${type}/styling.js`);
      window.injectCache[`components/Templates/components/${themeType.toLowerCase()}/${type}/styling.js`] = awaitStyle;
      return awaitStyle;
    }
    if (which === 'default') {
      if (window.injectCache[`components/Templates/components/${themeType.toLowerCase()}/${type}/defaultStyles.js`]) return window.injectCache[`components/Templates/components/${themeType.toLowerCase()}/${type}/defaultStyles.js`];
      const awaitDefault = await import(/* webpackMode: "lazy" */ `components/Templates/components/${themeType.toLowerCase()}/${type}/defaultStyles.js`);
      window.injectCache[`components/Templates/components/${themeType.toLowerCase()}/${type}/defaultStyles.js`] = awaitDefault;
      return awaitDefault;
    }   


  } catch(error) {
    console.log(error);
  }
    




}
